import { apiEndpoint, getStateParameterPath, retryApi } from ".";
import { localStorageEmailKey } from "../App";
import { JSONValue } from "../components/JsonEditor";

export interface CheckSharedStateAuthRequest {
  readonly name: JSONValue | undefined;
  readonly skipRetry?: boolean;
}

export interface CheckSharedStateAuthResponse {
  readonly value: boolean;
  readonly version?: number;
}

export async function checkSharedStateAuth(
  req: CheckSharedStateAuthRequest,
): Promise<CheckSharedStateAuthResponse | undefined> {
  if (!req.name || typeof req.name !== "string") {
    throw new Error("checkSharedStateAuth incorrect input value of name");
  }
  const token = localStorage.getItem("authToken");
  if (token) {
    // TODO - dumb hack...
    const sharedStateName = getStateParameterPath({
      email: localStorage.getItem(localStorageEmailKey) ?? "",
      sharedStateName: req.name,
    });
    const sharedCheck = `${sharedStateName}:${localStorage.getItem(localStorageEmailKey) ?? ""}`;
    const response = await fetch(
      `${apiEndpoint}/shared/${encodeURIComponent(sharedCheck)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      if ([401, 403].includes(response.status) && !req.skipRetry) {
        return retryApi({
          func: checkSharedStateAuth,
          funcProps: { name: req.name },
          response,
          token,
        });
      }
      // Extract error message if backend sends one
      const errText = await response.text();
      throw new Error(
        `Failed to verify shared state auth: ${response.status} ${errText}`,
      );
    }
    const jsonResp = JSON.parse(await response.json());
    return jsonResp as CheckSharedStateAuthResponse;
  }
}
